module.exports = __webpack_public_path__ + "img/marketea_logo_2023_blue.6f53a94d.svg";